import React, { useState } from 'react';
import Truncate from 'react-truncate';
import ReactResponsive from 'react-responsive';
import DumpPrivacyLink from './dumpPrivacyLink';

const Mobile = props => (
    <ReactResponsive {...props} maxWidth={768 - 1} />
);

const ReadMore = (props) => {
    const { privacyLinkUrl, readMoreText, readLessText, privacyPolicyText, updateSelectLink } = props;
    const [truncated, setTruncated] = useState(false);
    const [expanded, setExpanded] = useState(false);
    const [isNeedTruncate, setIsNeedTruncate] = useState(false);

    const onTruncate = (isTruncated) => {
        if (!isNeedTruncate && isTruncated) {
            setIsNeedTruncate(true);
        }

        setTruncated(isTruncated);
    };

    const toggleLines = () => {
        setExpanded(!expanded);
    };

    return ([
        <Truncate
            key="disclamier-truncated"
            onTruncate={onTruncate}
            lines={!expanded && 3}
        >
            {props.children}
        </Truncate>,
        (!isNeedTruncate || !truncated) &&
            <DumpPrivacyLink
                updateSelectLink={updateSelectLink}
                privacyLinkUrl={privacyLinkUrl}
                privacyPolicyText={privacyPolicyText} />,
        <div key="toggle-btn-container">
            {
                isNeedTruncate && <span className="toggle-btn" onClick={toggleLines}>
                    {!truncated ? readLessText : readMoreText}
                </span>
            }
        </div>
    ]);
};

const DumpDisclaimerMessage = (props) => { // TODO LOGIC
    const { hilightColor, disclaimerMsg, privacyLinkUrl, privacyPolicyText, readMoreText, readLessText, updateSelectLink } = props;

    return (
        <Mobile>
            {(match) => {
                if (match) {
                    return (
                        <div className="seismic-engagement-disclaimer-message">
                            <ReadMore
                                updateSelectLink={updateSelectLink}
                                privacyLinkUrl={privacyLinkUrl}
                                privacyPolicyText={privacyPolicyText}
                                hilightColor={hilightColor}
                                readMoreText={readMoreText}
                                readLessText={readLessText}>
                                {disclaimerMsg}
                            </ReadMore>
                        </div>
                    );
                }

                return (
                    <div className="seismic-engagement-disclaimer-message">
                        {disclaimerMsg}&nbsp;
                        <DumpPrivacyLink
                            updateSelectLink={updateSelectLink}
                            privacyLinkUrl={privacyLinkUrl || []}
                            privacyPolicyText={privacyPolicyText} />
                    </div>
                );
            }}
        </Mobile>
    );
};


export default DumpDisclaimerMessage;
